import {ReactElement} from 'react';
import {useSelector} from 'react-redux';
import {selectIsMarketplace} from '../../store/slices/channel/slice';

type Props = {
  children: ReactElement | ReactElement[];
};

export const Marketplace = ({children}: Props) => {
  const isMarketplace = useSelector(selectIsMarketplace);
  if (!isMarketplace) {
    return null;
  }
  return <>{children}</>;
};
